import './index.css';
import img1 from '../../../src/images/Left2.svg';
import img2 from '../../../src/images/Step 01.svg';
import img3 from '../../../src/images/cross-icon.svg';
import img4 from '../../../src/images/Radio Button.svg';
import img5 from '../../../src/images/Radio Button (1).svg';
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img12 from '../../../src/images/Icon (6).svg';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

function AIAnalysis1() {
    const navigate = useNavigate();
    const [cards, setCards] = useState([]);
    const [activeButton, setActiveButton] = useState(null);

    const handleButtonClick = (index) => {
        setActiveButton(index);
    };
    const navigateTo = (path) => {
        navigate(path);
    };
    return (
        <>
            <div className="dashboard_container ai-analysis-container">
                <div className="analysis_container">
                    <div className='analysis_navbar'>
                        <div>
                            <img src={img1} alt="" />
                        </div>
                        <div>
                            <h3>Choose Analysis Type</h3>
                        </div>
                        <div onClick={() => navigateTo('/')}>
                            <img src={img3} alt="" />
                        </div>
                    </div>
                    <div className='step_image'>
                        <img src={img2} alt="" />
                    </div>
                    <div className='analysis_heading'>
                        <h1>Choose Analysis Type</h1>
                        <p>1. Tap to select an option</p>
                    </div>
                    <div className='radio_container'>
                        <div className='radio_button'>
                            <div className='radio-image-button' onClick={() => handleButtonClick(1)}><img src={activeButton === 1 ? img4 : img5} alt="" /></div>
                            <div><h2>Analyze Individual Patient Data</h2></div>
                        </div>
                        <div className='radio_button'>
                            <div onClick={() => handleButtonClick(2)}><img src={activeButton === 2 ? img4 : img5} alt="" /></div>
                            <div><h2>Analyze Group Trends</h2></div>
                        </div>
                        <div className='radio_button'>
                            <div onClick={() => handleButtonClick(3)}><img src={activeButton === 3 ? img4 : img5} alt="" /></div>
                            <div><h2>Generate Summary Insights</h2></div>
                        </div>
                    </div>
                    <div className='analysis_heading'>
                        <p>2. or/ Press and hold the Ai Voice Command Button.</p>
                    </div>


                </div>
            </div>
            <div className='analysis-footer-wrapper'>
                <div className='ai-analysis-footer'>
                    <div className='ai-analysis-footer-btn' onClick={() => navigateTo('/aianalysis2')}>AI Voice Command</div>
                    <p>Speak your choice (e.g., “Analyze individual patient data” or “Group trends analysis”).</p>
                </div>
            </div>
                        <div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div style={{ cursor: "pointer" }}>
                        <img src={img12} alt="" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default AIAnalysis1;
